<template>
  <div class="admin-index">
    <div class="admin-left">
      <mynav></mynav>
    </div>
    <div class="admin-right">
      <h4 style="font-size: 24px; margin-bottom: 30px">业务列表</h4>
      <el-button type="primary" @click="show = true" style="margin-bottom: 40px"
        >添加</el-button
      >
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column width="300" prop="title" label="业务名称">
        </el-table-column>
        <el-table-column width="300" prop="english" label="业务英文名称">
        </el-table-column>
        <el-table-column min-width="400" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="mydelete(scope.row.id)"
              >删除</el-button
            >
            <el-button type="primary" @click="myupadte(scope.row)"
              >编辑</el-button
            >
            <el-button type="primary" @click="upBanner(scope.row.id)"
              >上移</el-button
            >
            <el-button type="primary" @click="downBanner(scope.row.id)"
              >下移</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          layout="total,sizes, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          :page-size="pageSize"
          :page-sizes="[10, 40, 60, 100]"
          @current-change="list"
          :current-page="pageNum"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="show" width="450px">
      <el-form
        ref="ruleForm"
        label-width="150px"
        label-position="left"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="业务名称" prop="title">
          <el-input
            v-model="form.title"
            placeholder="请输入业务名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务英文名称">
          <el-input
            v-model="form.english"
            placeholder="请输入业务英文名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-select v-model="form.lab" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="背景图" prop="url">
          <el-upload
            class="avatar-uploader"
            :action="uploadURL"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="CoverSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="封面图" prop="urls">
          <el-upload
            class="avatar-uploader"
            :action="uploadURL"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="CoverSuccess1"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-button
          type="primary"
          @click="sumbit('ruleForm')"
          v-if="!this.form.id"
          >提交</el-button
        >
        <el-button type="primary" v-else @click="mychange('ruleForm')"
          >修改</el-button
        >
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import mynav from "../../components/leftnav.vue";
import { getToken } from "../../token";
export default {
  data() {
    return {
      //弹框
      show: false,
      // 上传图片配置
      uploadURL: "",
      uploadHeaders: "",
      imageUrl: "",
      imageUrl1: "",
      //数据
      tableData: null,
      //分页
      pageSize: 10,
      pageNum: 1,
      total: 0,
      //分类
      options: [],
      // 新增数据
      form: {
        title: "",
        english: "",
        lab: "ALL",
        url: "",
        urls: "",
      },
      //form字段限制
      rules: {
        title: [
          { required: true, message: "业务名称不能为空", trigger: "blur" },
        ],
        url: [{ required: true, message: "背景图不能为空", trigger: "blur" }],
        urls: [{ required: true, message: "封面图不能为空", trigger: "blur" }],
      },
    };
  },
  components: {
    mynav,
  },
  created() {
    this.uploadURL = process.env.VUE_APP_BASE_API + "/oss/upload";
    this.uploadHeaders = {
      token: getToken(),
    };
    this.$axios.get("/front/getFrontCitys").then((res) => {
      let List = [
        {
          value: "ALL",
          label: "ALL",
        },
      ];
      res.data.forEach((element) => {
        List.push({
          value: element.name,
          label: element.name,
        });
      });
      this.options = List;
    });
    this.list(1);
  },
  watch: {
    show(val) {
      if (!val) {
        this.form = {
          title: "",
          english: "",
          lab: "ALL",
          url: "",
          urls: "",
          id: "",
        };
        this.imageUrl = "";
        this.imageUrl1 = "";
      }
    },
  },
  methods: {
    //获取数据
    list(val) {
      this.pageNum = val;
      this.$axios
        .get("/business/listType", {
          params: {
            pageSize: this.pageSize,
            pageNumber: this.pageNum,
          },
        })
        .then((res) => {
          this.tableData = res.data.list;
          this.total = res.data.totalRow;
        });
    },
    // 新增提交
    sumbit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post("/business/addType", this.form).then(() => {
            this.$message.success("新增成功");
            this.list(1);
            this.show = false;
          });
        } else {
          return false;
        }
      });
    },
    // 新增修改
    mychange(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post("/business/updateType", this.form).then(() => {
            this.$message.success("修改成功");
            this.list(1);
            this.show = false;
          });
        } else {
          return false;
        }
      });
    },
    // 点击修改
    myupadte(data) {
      this.form = {
        title: data.title,
        english: data.english,
        lab: data.lab,
        url: data.url,
        urls: data.urls,
        id: data.id,
      };
      this.imageUrl = data.url;
      this.imageUrl1 = data.urls;
      this.show = true;
    },
    //删除
    mydelete(id) {
      this.$confirm("此操作将删除该业务分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios.get("/business/deleteType?typeId=" + id).then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.list(1);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上移
    upBanner(id) {
      this.$axios.get("/business/upType?typeId=" + id).then((res) => {
        if (res.code == 200) {
          this.$message.success("上移成功");
          this.list(1);
        }
      });
    },
    //下移
    downBanner(id) {
      this.$axios.get("/business/downType?typeId=" + id).then((res) => {
        if (res.code == 200) {
          this.$message.success("下移成功");
          this.list(1);
        }
      });
    },
    //图片上传
    CoverSuccess(res) {
      if (res.code == 200) {
        this.imageUrl = res.data;
        this.$set(this.form, "url", res.data);
      } else {
        this.$message({
          type: "error",
          message: "上传banner图失败!",
        });
      }
    },
    CoverSuccess1(res) {
      if (res.code == 200) {
        this.imageUrl1 = res.data;
        this.$set(this.form, "urls", res.data);
      } else {
        this.$message({
          type: "error",
          message: "上传banner图失败!",
        });
      }
    },
    //改变列表分页数
    handleSizeChange(val) {
      this.pageSize = val;
      this.list(this.pageNum);
    },

    //上传格式限制
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 50;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 50MB!");
      }
      return isLt2M;
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style scoped lang="less">
.admin-index {
  display: flex;
  .admin-right {
    width: calc(100% - 252px);
    padding: 40px;
  }
  .footer {
    width: 100%;
    text-align: center;
    margin-top: 70px;
  }
}
</style>
